import styles from "../../Header.module.scss";
import MenuItem from "./MenuItem";
import { useRouter } from "next/compat/router";
import { useDispatch } from "react-redux";
import { isSubmenuVisible } from "@/redux/actions/headerAction";

function MainMenu({ menuItems }) {
  const router = useRouter();
  const isImpactOrCharityPage =
    router.pathname !== "/404" && (router.asPath.startsWith("/impact") || router.asPath.startsWith("/charity")) ;
  const dispatch=useDispatch();
  //Add delay on hover of menu
  let enterTimeout;
  let leaveTimeout;
  const handleMouseEnter = () => {
    clearTimeout(leaveTimeout); //To avoid conflicting actions on mouse leave
    enterTimeout = setTimeout(() => {
      dispatch(isSubmenuVisible(true))
    }, 500); 
  }

  const handleMouseLeave = () => {
    clearTimeout(enterTimeout); // To avoid conflicting actions on mouse enter
    leaveTimeout = setTimeout(() => {
      dispatch(isSubmenuVisible(false))
    });
  }

  return (
    <section className={styles.main_menu_section}>
      <div className={`container-fluid mw-960 ${isImpactOrCharityPage ? styles.impact_container : ""}`}>
        <div className="row">
          <div className="grid-md-12">
            <ul
              onMouseEnter={()=> handleMouseEnter()} 
              onMouseLeave={()=> handleMouseLeave()}
              className={`${
                isImpactOrCharityPage ? `${styles.impact_class}` : ""
              } auto-menuBar ${styles.main_menu_list}`}
            >
              {menuItems.map((menuItem, index) => {
                return <MenuItem key={index} menuItem={menuItem} isLast={menuItems.length-1==index} isSecondLast={menuItems.length-2==index} />;
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainMenu;
